import { memo } from 'react';

import { TriggerPanel } from '@/components/flow';

import { SlideOut } from './SlideOut.tsx';

export type TriggerPanelSlideOutProps = {
  actionId: string;
  agentId: string;
};

const ITriggerPanelSlideOut = ({ agentId, actionId }: TriggerPanelSlideOutProps) => {
  return (
    <SlideOut>
      <TriggerPanel agentId={agentId} actionId={actionId} />
    </SlideOut>
  );
};

export const TriggerPanelSlideOut = memo(ITriggerPanelSlideOut) as typeof ITriggerPanelSlideOut;
